export default {
  info: "Profile",
  signature: "Signature",
  dataSetting: "Profile Settings",
  logOut: "Log Out",
  account: "Account",
  oldPassword: "Current Password",
  newPassword: "New Password",
  confirmPassword: "Confirm Password",
  passwordsNotMatch: "Passwords do not match",
};
